import {observable} from 'mobx';
import {ModelProperties, createInstance} from 'utils';
import {SeoApp} from './seo-app';

export class SeoAppAudio {
    @observable id!: number;

    @observable type!: string;

    @observable appId!: number;

    @observable wordId!: number;

    @observable app?: SeoApp;

    constructor(audios?: ModelProperties<SeoAppAudio>) {
        if (audios) {
            Object.assign(this, audios);
            this.app = createInstance(SeoApp, audios.app);
        }
    }
}